import { useProfile } from '@discovr/common';
import type { ReportExportJob } from '@discovr/types';

export interface CurrentUser {
  /** The record id an export's `requested_by.id` carries; undefined until the profile loads. */
  userId: string | undefined;
  isLoading: boolean;
}

export function useCurrentUser(): CurrentUser {
  const { data, isPending } = useProfile();
  return { userId: data?.id, isLoading: isPending };
}

/** Only the requester may cancel. An unknown viewer or a job without a requester is never the owner. */
export function isExportOwner(job: { requested_by?: Pick<ReportExportJob['requested_by'], 'id'> | null }, userId: string | undefined): boolean {
  const ownerId = job.requested_by?.id;
  return Boolean(userId) && Boolean(ownerId) && ownerId === userId;
}
